export default "__VITE_ASSET__DPgVpTJd__"